
import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-white border-t border-slate-200 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center mb-12">
          <div className="mb-8 md:mb-0 text-center md:text-left">
            <span className="text-3xl font-bold tracking-tighter text-slate-900 block mb-2">
              DECOMAST
            </span>
            <p className="text-slate-500 text-sm">Calidad y elegancia en cada detalle de acero.</p>
          </div>
          
          <div className="flex space-x-6">
            <a href="#" className="w-10 h-10 rounded-full border border-slate-200 flex items-center justify-center text-slate-600 hover:bg-slate-900 hover:text-white transition-all">
              <i className="fa-brands fa-facebook-f"></i>
            </a>
            <a href="#" className="w-10 h-10 rounded-full border border-slate-200 flex items-center justify-center text-slate-600 hover:bg-slate-900 hover:text-white transition-all">
              <i className="fa-brands fa-instagram"></i>
            </a>
            <a href="#" className="w-10 h-10 rounded-full border border-slate-200 flex items-center justify-center text-slate-600 hover:bg-slate-900 hover:text-white transition-all">
              <i className="fa-brands fa-tiktok"></i>
            </a>
          </div>
        </div>

        <div className="border-t border-slate-100 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-slate-400 text-sm mb-4 md:mb-0">
            &copy; {new Date().getFullYear()} DECOMAST. Todos los derechos reservados.
          </p>
          <div className="flex space-x-8 text-slate-400 text-sm">
            <a href="#" className="hover:text-slate-900">Privacidad</a>
            <a href="#" className="hover:text-slate-900">Términos</a>
            <a href="#" className="hover:text-slate-900">Garantía</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
